import { Stack } from "@fluentui/react";
import FlagIndicator from "./FlagIndicator";

interface FlagIndicatorsRowProps {
    isTCT?: number;
    isCAT?: number;
    hasEngagedAdmin?: number;
}

export default function FlagIndicatorsRow({
    isTCT,
    isCAT,
    hasEngagedAdmin,
}: FlagIndicatorsRowProps) {
    const shouldRender =
        (isTCT === 0 || isTCT === 1 || isCAT === 0 || isCAT === 1 || hasEngagedAdmin === 0 || hasEngagedAdmin === 1);

    if (!shouldRender) return null;

    return (
        <div style={{ marginTop: 8 }}>
            <Stack tokens={{ childrenGap: 12 }}>
                <Stack
                    horizontal
                    wrap
                    tokens={{ childrenGap: 10, padding: 3 }}
                    styles={{ root: { paddingLeft: 10 } }}
                >
                    <FlagIndicator label="IsTCT" value={isTCT} />
                    <FlagIndicator label="IsCAT" value={isCAT} />
                    <FlagIndicator label="IsEngagedTenantAdmin" value={hasEngagedAdmin} />
                </Stack>
            </Stack>
        </div>
    );
}
